import { css } from "styled-components";
import token from "styled-token";
import { StyledLabeledControl } from "../../components/LabeledControl/LabeledControl";
/** @class SwitchGroupMixin */

/** @method */

export var SwitchGroupMixin = token("SwitchGroup.borderColor", function (borderColor) {
  return css(["> ", "{border-top:1px solid ", ";&:last-child{border-bottom:1px solid ", ";}}"], StyledLabeledControl, borderColor, borderColor);
});